import { render, staticRenderFns } from "./PracticeLibExam.vue?vue&type=template&id=328b5177&"
import script from "./practiceLibExam.js?vue&type=script&lang=js&"
export * from "./practiceLibExam.js?vue&type=script&lang=js&"
import style0 from "./practiceLibExam.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports